import * as React from "react";
import { Modal } from "kanopi-components/Modal";
import { quoteFlowFields } from "kw/api/fragments";
import { useMatchParams } from "kanopi-components/hooks/useMatchParams";
import { useStyletron } from "kanopi-components/theme/useStyletron";
import {
  QuestionFlowComponent,
  QuestionFlowTypeEnum,
} from "kw/components/QuestionFlow/QuestionFlowComponent";

type ExposureFlowModalProps = {
  isOpen: boolean;
  openModal: (arg: boolean) => void;
  title: string;
  exposureItem: unknown;
  onComplete?: (...args: unknown[]) => void;
  finalButtonText?: string;
  riskProfileId: string;
  loading?: boolean;
};
export const ExposureFlowModal: React.FC<ExposureFlowModalProps> = ({
  isOpen,
  openModal,
  title,
  exposureItem,
  onComplete,
  riskProfileId,
}) => {
  const [, theme] = useStyletron();
  const { questionSetKey } = useMatchParams("/quote/ready/:questionSetKey");
  const startExposureQuery = {
    startExposure: [
      {
        input: {
          riskProfileId,
          exposureId: exposureItem?.exposure_id,
          questionSetKey,
        },
      },
      { ...quoteFlowFields },
    ],
  };
  const [currentMaxSet, setCurrentMaxSet] = React.useState({
    currentSet: 0,
    maxSets: 1,
  });
  const [nextButtonText, setNextButtonText] = React.useState<string>();
  const onQuestionFlowFinish = React.useCallback(async () => {
    openModal(false);
    onComplete?.();
  }, []);

  const onCurrentMaxSetChange = (currentSet, maxSets) => {
    const _totalSets = { ...currentMaxSet };
    _totalSets.currentSet = !questionSetKey && currentSet === maxSets ? 0 : currentSet;
    _totalSets.maxSets = maxSets;
    setCurrentMaxSet(_totalSets);
    const _nextButtonText = currentSet === maxSets - 1 ? "Add" : "Next";
    setNextButtonText(_nextButtonText);
  };
  return (
    <Modal onClose={() => openModal(false)} closeable isOpen={isOpen} animate autoFocus>
      <Modal.Header $style={{ textAlign: "center" }}>{title}</Modal.Header>
      <Modal.Body $style={{ marginTop: theme.sizing.scale800 }}>
        <QuestionFlowComponent
          isFlowLayout={false}
          actionFlowType={QuestionFlowTypeEnum.Exposure}
          prefix={"/quote/ready/exposure/add"}
          defaultBackLocation=""
          finishedRoute="/quote/ready"
          actionQuery={startExposureQuery}
          questionFlowResponseKey="startExposure"
          questionSetKey={questionSetKey}
          onCurrentAndMaxSetChange={onCurrentMaxSetChange}
          nextButtonText={nextButtonText}
          onQuestionFlowFinish={onQuestionFlowFinish}
        />
      </Modal.Body>
    </Modal>
  );
};
